import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { RouterExtensions } from '@luggagehero/core';
import { AcceptTermsOfServiceBaseComponent } from '@luggagehero/features/shop-manager';
import { SharedDocumentService } from '@luggagehero/shared/services/document';
import { SharedUserService } from '@luggagehero/shared/services/users';

@Component({
  selector: 'lh-accept-terms-of-service',
  templateUrl: 'accept-terms-of-service.component.html',
  styleUrls: ['accept-terms-of-service.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcceptTermsOfServiceComponent extends AcceptTermsOfServiceBaseComponent {
  constructor(
    formBuilder: FormBuilder,
    userService: SharedUserService,
    documentService: SharedDocumentService,
    router: RouterExtensions,
    cd: ChangeDetectorRef,
  ) {
    super(formBuilder, userService, documentService, router, cd);
  }
}
